import { render, staticRenderFns } from "./DurationText.vue?vue&type=template&id=7347ed1a&scoped=true&"
import script from "./DurationText.vue?vue&type=script&lang=js&"
export * from "./DurationText.vue?vue&type=script&lang=js&"
import style0 from "./DurationText.vue?vue&type=style&index=0&id=7347ed1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347ed1a",
  null
  
)

export default component.exports